var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextMessageWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38909 1.61135C7.23973 -0.536956 3.76089 -0.537278 1.61122 1.61135C-0.117183 3.33888 -0.443791 5.9076 0.578047 7.95326L0.0115422 10.4439C-0.0620916 10.7676 0.228184 11.0579 0.552191 10.9843L3.04406 10.4181C6.66722 12.2261 11 9.60849 11 5.49839C11 4.0301 10.4279 2.64965 9.38909 1.61135ZM6.64743 6.86727H3.20559C2.9561 6.86727 2.75385 6.66512 2.75385 6.41575C2.75385 6.16638 2.9561 5.96423 3.20559 5.96423H6.64743C6.89692 5.96423 7.09917 6.16638 7.09917 6.41575C7.09917 6.66512 6.89692 6.86727 6.64743 6.86727ZM7.79472 5.03253H3.20559C2.9561 5.03253 2.75385 4.83038 2.75385 4.58101C2.75385 4.33165 2.9561 4.12949 3.20559 4.12949H7.79472C8.04421 4.12949 8.24646 4.33165 8.24646 4.58101C8.24646 4.83038 8.04419 5.03253 7.79472 5.03253Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextMessageWhite);
export default __webpack_public_path__ + "static/media/text-message-white.e49fa75efc9126fdb925f2f9645992a7.svg";
export { ForwardRef as ReactComponent };